module.exports = __webpack_public_path__ + "img/niajian.b1a77e00.svg";